<template>
  <div class="p-4 md:p-6">
    <form @submit.prevent="validateBeforeSubmit()" class="md:w-1/2">
      <div class="mb-1 pb-1 border-b">
        <p class="text-lg">
          <i class="fa fa-key text-brand"></i> Change Password
        </p>
      </div>

      <div class="py-1">
        <label class="font-medium" for="old_password">Current Password</label>
        <input
          id="old_password"
          class="w-full border py-2 px-3 mt-1 rounded"
          type="password"
          name="old_password"
          autocomplete="current-password"
          data-vv-validate-on="blur"
          v-model="old_password"
          v-validate="'required'"
          :class="{ 'border-red': errors.has('old_password') }"
        />
        <p class="text-red text-sm mt-1" v-if="errors.has('old_password')">{{ errors.first("old_password") }}</p>
      </div>

      <div class="py-1">
        <label class="font-medium" for="password">
          New Password
          <span class="text-xs text-grey-darker font-normal ml-1">At least 8 characters</span>
        </label>
        <input
          id="password"
          class="w-full border py-2 px-3 mt-1 rounded"
          type="password"
          name="password"
          ref="password"
          autocomplete="new-password"
          v-model="password"
          data-vv-validate-on="blur"
          v-validate="'required|min:8'"
          :class="{ 'border-red': errors.has('password') || invalid_password }"
        />
        <p class="text-red text-sm mt-1" v-if="errors.has('password')">{{ errors.first("password") }}</p>
        <p
          class="text-red text-sm mt-1"
          v-for="(messages, type) in password_errors"
          :key="type"
          v-if="invalid_password"
        >
          {{ join(messages) }}
        </p>
      </div>

      <div class="py-1">
        <label class="font-medium" for="confirm_password">Confirm New Password</label>
        <input
          id="confirm_password"
          class="w-full border py-2 px-3 mt-1 rounded"
          type="password"
          name="confirm_password"
          autocomplete="new-password"
          v-model="confirm_password"
          data-vv-validate-on="blur"
          v-validate="'required|confirmed:password'"
          :class="{ 'border-red': errors.has('confirm_password') }"
        />
        <p class="text-red text-sm mt-1" v-if="errors.has('confirm_password')">{{ errors.first("confirm_password") }}</p>
      </div>

      <!-- submit under the fields, left aligned, like the other forms -->
      <div class="mt-4">
        <button
          type="submit"
          class="border border-brand bg-brand text-white text-sm font-medium py-2 px-4 rounded hover:bg-brand-darkest"
          :class="{ 'cursor-not-allowed opacity-75': sending_request }"
          :disabled="sending_request"
        >
          <span v-if="sending_request"><i class="fa fa-spinner fa-spin mr-1"></i> Changing</span>
          <span v-else>Change password</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      old_password: "",
      password: "",
      confirm_password: "",
      password_errors: "",
      invalid_password: "",

      sending_request: false,
    };
  },

  methods: {
    join(err) {
      return _.join(err);
    },
    fixFormErrors(errors) {
      let errs = [errors];
      return _.reduce(
        errs,
        function(object, value) {
          return _.assign(object, value);
        },
        {}
      );
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          axios
            .post("/api/register/test-password", {
              password: this.password
            })
            .then(({ data }) => {
              this.invalid_password = false;
              if (data.success) {
                this.sending_request = true;
                axios
                  .post("/api/users/password", {
                    old_password: this.old_password,
                    password: this.password
                  })
                  .then(response => {
                    this.sending_request = false;
                    this.old_password = "";
                    this.password = "";
                    this.confirm_password = "";

                    let data = response.data;
                    if (data.success) {
                      this.$noty.success(data.message || "Password changed", { killer: true, timeout: 3000 });
                    } else {
                      this.$noty.warning(data.message || "The password was not changed", { killer: true, timeout: 4000 });
                    }
                  })
                  .catch(error => {
                    this.sending_request = false;
                    this.old_password = "";
                    this.password = "";
                    this.confirm_password = "";
                    this.$validator.reset();

                    const data = error.response && error.response.data;
                    this.$noty.error((data && data.message) || "The password could not be changed", { killer: true, timeout: 4000 });
                  });
              }
            })
            .catch(error => {
              this.password_errors = [];
              let data = error.response.data;
              if (data != "") {
                if (!_.isNil(data.errors) && _.isObject(data.errors)) {
                  let form_errors = this.fixFormErrors(data.errors);
                  this.password_errors = form_errors;
                  this.invalid_password = true;
                }
              }
            });
        }
      });
    }
  }
};
</script>

<style>
</style>
